import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { WinMeterContainer } from "./WinMeterContainer";

export class WinMeterComponent extends AbstractDisplayComponent {
    private container: WinMeterContainer;

    public override init() {
        let config = {
            labelName: "winMeterComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 500,
                posY: 500,
                scale: 1,
            },
            portrait: {
                posX: 1000,
                posY: 600,
                scale: 0.95,
            }
        };

        super.init();
        this.container = new WinMeterContainer(config);
    }

    public getInstance(): WinMeterContainer {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy();
    }
}
